import React, {Component} from 'react';
import format from 'date-fns/format';
import request from 'utils/request';
import classnames from 'classnames';
import {getPickTimestamp} from 'components/Cards/Pick/helpers';

import {Leagues, Teams} from './checks'; // eslint-disable-line
import * as checks from './checks'; // eslint-disable-line

import './pick.scss';

const dictionary = {
  time_to_win: 'Time to win',
  time_to_draw: 'Time to draw',
  time_to_lose: 'Time to lose',
  time_to_btts: 'Time to score',
  total_goals: 'Total goals',
  favorite_team: 'Favorite team',
};

class Pick extends Component {
  state = {
    loading: true,
  };

  componentDidMount() {
    request
      .get(`/v3/shared/strategies/${this.props.match.params.strategyId}/picks/${this.props.match.params.pickId}`)
      .then(({data: pick}) => this.setState({loading: false, pick}))
      .catch(() => this.setState({loading: false}));
  }

  renderScore() {
    const {pick} = this.state;

    return (
      <div className="pick-score">
        <div className="score">
          <span>{pick.event.score.home}</span>
        </div>
        <div className="score">
          <span>{pick.event.score.away}</span>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="loading">
          <span>Loading pick details...</span>
        </div>
      );
    }

    if (!this.state.pick) {
      return <div>Pick not found</div>;
    }

    const {pick} = this.state;
    const {event} = pick;

    let pickTitle = `${pick.odd}`;
    switch (pick.pick) {
      case 'home':
      case 'draw':
      case 'away':
        pickTitle = `${pick.pick === 'draw' ? 'Draw' : event[pick.pick].name}@${pickTitle}`;
        break;
      case 'btts.yes':
        pickTitle = `BTTS Yes@${pickTitle}`;
        break;
      case 'btts.no':
        pickTitle = `BTTS No@${pickTitle}`;
        break;
      case 'TGU2.5':
        pickTitle = `Total Under 2.5@${pickTitle}`;
        break;
      case 'TGO2.5':
        pickTitle = `Total Over 2.5@${pickTitle}`;
        break;
      default:
        throw new Error('Unknown pick pick');
    }

    return (
      <div className="pick-page">
        <div className="pick-details">
          {pick.resolved && this.renderScore()}
          <div
            className={classnames('pick-pick', {
              red: pick.result === 'lose',
              green: pick.result === 'win',
            })}
          >
            {pickTitle}
          </div>
          <div className="pick-event-info">
            {format(getPickTimestamp(pick.event) * 1000, 'D MMM HH:mm')},{event.league.name}
            <br />
            {event.home.name} —{event.away.name}
          </div>
        </div>
        <div className="pick-strategy-title">
          Strategy: <b>{dictionary[pick.strategyType]}</b>
        </div>
        <ul>
          {pick.strategy.leagues && <Leagues {...pick} />}
          {pick.strategy.teams && <Teams {...pick} />}
          {Object.keys(pick.checks).map(key => {
            const Check = checks[key];
            if (!Check) return null;
            return <Check key={key} {...pick} />;
          })}
        </ul>
        <p className="pick-stats-actual">
          Stats and Odds are actual for {format(pick.placedAt._seconds * 1000, 'D MMM HH:mm')}
        </p>
      </div>
    );
  }
}

export default Pick;
